import { shareOrigin } from "@/lib/origin";
import { useEffect, useState } from "react";
import { Send, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/apiClient";

// Friends who've just played Adelaida's personal message, each with a ready-made nudge.
export default function InviteNudges() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/invites/nudges").then((r) => setRows(r.data)).catch(() => {}); }, []);
  const done = (t) => { setRows((r) => r.filter((x) => x.token !== t)); api.post(`/invites/${t}/nudge-done`).catch(() => {}); };
  const send = async (n) => {
    const url = `${shareOrigin()}${n.path}`;
    try {
      if (navigator.share) await navigator.share({ text: n.text, url });
      else { await navigator.clipboard.writeText(`${n.text} ${url}`); toast("Nudge copied. Paste it to " + n.friend + "."); }
      done(n.token);
    } catch (e) { if (e?.name !== "AbortError") toast("Couldn't share that. Please try again."); }
  };
  if (!rows.length) return null;
  return (
    <div className="mb-10 space-y-3" data-testid="invite-nudges">
      {rows.map((n) => (
        <div key={n.token} className="relative rounded-3xl border border-primary/25 bg-primary/[0.05] p-5 sm:p-6" data-testid={`invite-nudge-${n.token}`}>
          <button onClick={() => done(n.token)} className="absolute top-4 right-4 text-muted-foreground hover:text-foreground" aria-label="Dismiss" data-testid={`invite-nudge-dismiss-${n.token}`}><X className="w-4 h-4" /></button>
          <p className="text-[10px] uppercase tracking-[0.22em] text-primary">Your invite was heard</p>
          <p className="font-serif text-lg sm:text-xl leading-snug mt-2 pr-6">{n.friend} just listened to Adelaida's message.</p>
          <p className="text-sm text-muted-foreground mt-2 italic" data-testid={`invite-nudge-text-${n.token}`}>"{n.text}"</p>
          <button onClick={() => send(n)} className="mt-4 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary text-primary-foreground text-sm" data-testid={`invite-nudge-send-${n.token}`}>
            <Send className="w-4 h-4" /> Send {n.friend} a nudge
          </button>
        </div>
      ))}
    </div>
  );
}
